import ALL_FILTERS from 'components/molecules/TagFilter/factories';
import { POOL_TYPE } from 'defs/pools';
import { getFilters, RootStateType as TransientPoolRootStateType } from 'store/transientPoolState';
import { DYNAMIC_PRODUCT_CLUSTER_TYPE, MetaDataType, RootStateType } from '.';

const _getFavoriteById = (state: RootStateType, id: string | number): Object => {
	const map = state.favorites.byId || {};
	return map[id] || {};
};

export const getFavorites = (state: RootStateType, cluster: string = 'ALL'): any[] => {
	switch (cluster) {
		case 'EXERCISE':
			cluster = 'TODO';
			break;
		case 'RECOMMENDATION':
			cluster = 'PRODUCT';
			break;
		default:
			break;
	}

	if (!state.favorites || !state.favorites.byCluster || !state.favorites.byCluster[cluster]) {
		return [];
	}

	return state.favorites.byCluster[cluster];
};

export const getDynamicProductFavorites = (state: RootStateType): any[] => {
	if (!state.favorites || !state.favorites.byCluster || !state.favorites.byCluster[DYNAMIC_PRODUCT_CLUSTER_TYPE]) {
		return [];
	}

	return state.favorites.byCluster[DYNAMIC_PRODUCT_CLUSTER_TYPE];
};

export const getFavoritesMetaData = (state: RootStateType): MetaDataType[] => {
	return state.favorites.metaData;
};

export const getFavoritesLength = (state: RootStateType): number => {
	return state.favorites.metaData.length;
};

export const getFavoritesMetaDataQuery = (state: RootStateType): string | void => {
	const metaData = getFavoritesMetaData(state);
	if (!metaData || metaData.length <= 0) {
		return undefined;
	}

	return getFavoritesMetaData(state)
		.map(({ type, externalId }: MetaDataType) => `${type}:${externalId}`)
		.join(',');
};

export const getSelectedFavorite = (state: RootStateType, id: string): Object => {
	return _getFavoriteById(state, id);
};

export const getIsFavorite = (state: RootStateType, id: string): boolean => {
	const item: any = _getFavoriteById(state, id);
	return !!(item.favoriteMeta || {}).isFavorite;
};

export const getIsFavoriteFromInternalState = (state: RootStateType, id: string): boolean => {
	return Boolean(state.favorites.toggleState[id]);
};

export const getTotalFavoriteCount = (state: RootStateType) => {
	return state.favorites.count >= 0 ? state.favorites.count : -1;
};

export const getTotalFavoriteCountWithDynamicProducts = (state: RootStateType) => {
	return state.favorites.count >= 0 ? state.favorites.countWithDynamicProducts : -1;
};

export const getRemovedItemsPipe = (state: RootStateType): Array<any> => {
	return state.favorites.removedItemsPipe || [];
};

export const getFavoriteIds = (state: RootStateType): string[] => {
	if (!state.favorites.byId) {
		return [];
	}

	return Object.keys(state.favorites.byId) || [];
};

export const getFavoritesForPool = (
	state: RootStateType & TransientPoolRootStateType,
	cluster: 'RECIPE' | 'WORKOUT'
): { items: any[]; total: number } => {
	let favorites = getFavorites(state, cluster);
	const filters = getFilters(state, POOL_TYPE[cluster]);
	const filterPipeline = Object.keys(filters)
		.map((filterId: string) => {
			if (ALL_FILTERS[filterId] && filters[filterId] && filters[filterId] !== 'NONE') {
				return ALL_FILTERS[filterId].filter(filters[filterId]);
			}

			return undefined;
		})
		.filter(Boolean);

	if (favorites) {
		favorites = favorites || [];
	}

	return {
		items: filterPipeline.reduce((prev: any[], filterFn) => {
			if (filterFn) {
				return prev.filter(filterFn as any);
			}

			return prev;
		}, favorites),
		total: favorites.length,
	};
};
